import { objectify } from 'radash';

export interface SelectItem {
  key: string;
  value: string;
}

export const createSelectItemLookup = (selectItems: SelectItem[]): ((key: string) => string) => {
  const keyMap = objectify(
    selectItems,
    (item) => item.key,
    (item) => item.value
  );
  return (key: string) => keyMap[key] || key;
};

export const resolveStaticSelectionValues = (keys: string[], selectItems: SelectItem[]): string =>
  keys.map(createSelectItemLookup(selectItems)).join(', ');
